import React from 'react';

export const name = 'plus';

export const Plus = () => (
  <svg viewBox="0 0 24 24" color="#6C717C" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.76001 12.0898H21.24"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M12.0151 2.75244V21.2474"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);
